// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Footer_Wrapper__L_i7k","Container":"Footer_Container__YSpx8","Short":"Footer_Short__jR9Or"};